import React, {Component} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

class MapaModal extends Component{
  constructor(props){
    super(props);
    this.state={
    }
  }

  render(){
    return(
      <div>
        <GoogleMap
          ref='map'
          defaultZoom={12}
          center={this.props.coordenadas}
          onClick={this.props.setMarker}>
          {this.props.showMarker && <Marker position={this.props.coordenadas} 
					/>}
            {this.props.children}
        </GoogleMap>
      </div>
    )
  }
}
export default withGoogleMap(MapaModal);


// WEBPACK FOOTER //
// ./src/Components/Rutas/mapaModal.js